import templateUrl from "emun.order/inactive-orders/inactive-orders-list.htm";
import controller from "emun.order/inactive-orders/inactive-orders-list.controller";

export default {
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
